import * as PropTypes from 'prop-types';
import * as React from 'react';
import UrlHelpers from '../../shared/url_helpers';
import * as classNames from 'classnames';
import { APIRequest } from '@reverbdotcom/discovery-ui';
import CartActions from '../../cart/cart_actions';
import SuccessModalContainer from './success_modal_container';
import { Modal, UserStore, HashUtil, Tracker } from '@reverbdotcom/discovery-ui';

// Like AjaxAddToCartButton but adds multiple products to your cart.
class AjaxMultiAddToCartButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isAdding: false,
      isModalOpen: false,
      successMessage: null,
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleError = this.handleError.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  componentDidMount() {
    this.$quantitySelector = $('.jq-checkout-quantity');
  }

  quantity() {
    if (this.$quantitySelector.length === 0) { return null; }

    return this.$quantitySelector.val();
  }

  showSellerBlock() {
    Reverb.BlockSellerAction.showMessage(I18n.t('js.addToCart.sellerBlockMessage'));
  }

  handleClick() {
    Tracker.trackInteraction({ name: this.props.trackName });

    if (this.props.isOwner) {
      this.showSellerBlock();
      return;
    }

    this.setState({ isAdding: true });

    APIRequest.V3.post(
      UrlHelpers.addMultipleToCartPath,
      JSON.stringify(this.params()),
      {
        contentType: 'application/json',
      },
    )
      .then(this.handleSuccess)
      .fail(this.handleError);
  }

  updateFacebook() {
    const metaData = ({ content_type: 'Product', content_ids: this.props.productIds });
    if (window.fbq) {
      window.fbq('track', 'AddToCart', metaData);
    }
  }

  handleSuccess(response) {
    this.updateFacebook();

    CartActions.loadCart();
    this.setState({
      isAdding: false,
      successMessage: response.message,
      isModalOpen: true,
    });
  }

  handleError(response) {
    this.setState({
      isAdding: false,
    });
    this.props.onError(response.responseJSON.message);
  }

  handleCloseModal() {
    this.setState({
      isModalOpen: false,
    });
  }

  params() {
    return {
      products: this.productParams(),
      _aid: this.props.aid,
      source: this.props.source,
      action_source_attributes: {
        device: UserStore.getState().deviceType,
      },
    };
  }

  productParams() {
    return this.props.productIds.map(productId => HashUtil.rejectBlankValues({
      id: productId,
      quantity: this.quantity(),
    }));
  }

  renderButtonText() {
    if (this.state.isAdding) {
      return I18n.t('js.addToCart.button.adding');
    } else if (this.props.onPreorder) {
      return I18n.t('js.addToCart.button.preorder');
    }

    return this.props.text || I18n.t('js.addToCart.button.add');
  }

  renderSuccessModal() {
    return (
      <Modal
        isOpen={this.state.isModalOpen}
        onRequestClose={this.handleCloseModal}
        subClass="cart-upsell"
        paddedBody
        newClose
      >
        <SuccessModalContainer
          productIds={this.props.productIds}
          message={this.state.successMessage}
          zeroPercentAffirmFinancing={this.props.zeroPercentAffirmFinancing}
        />
      </Modal>
    );
  }

  render() {
    const buttonText = this.renderButtonText();

    return (
      <div>
        <button
          onClick={this.handleClick}
          className="add-to-cart-button"
          aria-label={buttonText}
          disabled={this.state.isAdding || null}
        >
          {buttonText}
        </button>
        {this.renderSuccessModal()}
      </div>
    );
  }
}

AjaxMultiAddToCartButton.propTypes = {
  productIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  text: PropTypes.string,
  isOwner: PropTypes.bool,
  onPreorder: PropTypes.bool,
  aid: PropTypes.string,
  source: PropTypes.string,
  onError: PropTypes.func,
  zeroPercentAffirmFinancing: PropTypes.bool,
  trackName: PropTypes.string,
};

AjaxMultiAddToCartButton.defaultProps = {
  isOwner: false,
  onError: () => {},
  trackName: 'add_to_cart',
};

export default AjaxMultiAddToCartButton;



// WEBPACK FOOTER //
// ./javascripts/components/listings/cart/ajax_multi_add_to_cart_button.jsx